import * as React from 'react';
import ConfirmModalOkCancelV4 from './ConfirmModalOkCancelV4.jsx'

class ConfirmModalSaveV4 extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ConfirmModalSaveV4.jsx] ';
        this.state = {}
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div>
                < ConfirmModalOkCancelV4 id='close' show={this.props.show} className={'modal-dialog-centered'}>

                    <ConfirmModalOkCancelV4.Header
                        className={this.props.classNameHeader}
                        classNameTitle={this.props.classNameTitle}
                        testoTitle={(this.props.testoTitle !== undefined && this.props.testoTitle !== null) ?
                            this.props.testoTitle : "Salva"}
                        id={this.props.id}
                        onClose={this.props.onClose} />

                    <ConfirmModalOkCancelV4.Body className={this.props.classNameBody}
                        classNameTesto={this.props.classNameTesto}
                        testoBody={(this.props.testoBody !== undefined && this.props.testoBody !== null) ?
                            this.props.testoBody : "Confermi di voler salvare?"} />

                    <ConfirmModalOkCancelV4.Footer className={this.props.classNameFooter}
                        IdConfirm={this.props.IdConfirm}
                        classNameTestoButtonConfirm="btn btn-success"
                        classNameIconConfirm={this.props.classNameIconConfirm}
                        testoButtonConfirm= {(this.props.testoButtonConfirm !== undefined && this.props.testoButtonConfirm !== null) ?
                        this.props.testoButtonConfirm : "Salva"}
                        IdCancel={this.props.IdCancel}
                        classNameTestoButtonCancel={this.props.classNameTestoButtonCancel}
                        classNameIconCancel={this.props.classNameIconCancel}
                        testoButtonCancel={this.props.testoButtonCancel}
                        confirmOnClick={this.props.saveOnClick} onClose={this.props.onClose} />

                </ConfirmModalOkCancelV4 >
            </div>
        );
    }
};

export default ConfirmModalSaveV4;
